<template>
  <div class="translate-home">
    <DeleteDialog ref="deleteDialogRef" @onDelete="handleDeleteCall"/>
    <AiHistory ref="aiHistoryRef" />
    <div class="translate-home-header">
      <div class="page-back" @click="goBack">
        <WorkbenchIcon name="chevron-left" :size="15" />
      </div>
    </div>
    <tabView @onChangeType="onChangeType" :translateType="tabIndex">
    </tabView>

    <!-- 上传翻译 -->
    <div v-show="tabIndex == 0" class="translate-document-panel">
      <!-- 上传区域 -->
      <div class="upload-section">
        <TranslateUpload enterprise-mode @translateSuccess="translateSuccess" @taskCompleted="taskCompleted"/>
      </div>

      <!-- 最近文件列表 -->
      <div class="recent-section" v-if="sortedFiles.length > 0">
        <div class="section-header">
          <h2 class="section-title">{{$t('account_translate_recent')}}</h2>
          <div class="section-actions">
            <!-- <div class="sort-dropdown">
              <span class="sort-text">新文件优先</span>
              <i class="sort-arrow">▼</i>
              <div class="sort-menu">
                <div class="sort-item" @click="setSortOrder('new')">新文件优先</div>
                <div class="sort-item" @click="setSortOrder('old')">旧文件优先</div>
              </div>
            </div> -->
            <!-- <button class="delete-btn" @click="deleteSelected" :disabled="!hasSelected">
              🗑️
            </button> -->
            <i class="iconfont icon-icon_delete" :style="{color: hasSelected ? '#2590E1' : '#595959', cursor: hasSelected ? 'pointer' : 'auto'}" @click="deleteSelected" v-if='selectedFiles.length > 0'/>
          </div>
        </div>

        <div class="file-table">
          <div class="table-header">
            <div class="header-cell checkbox">
              <input
                id="custom-checkbox"
                type="checkbox"
                :checked="isAllSelected"
                @change="toggleSelectAll"
              />
            </div>
            <div class="header-cell name">{{$t('account_translate_recent_name')}}</div>
            <div class="header-cell status">{{$t('account_translate_recent_status')}}</div>
            <div class="header-cell creator">{{$t('account_translate_recent_creator')}}</div>
            <div class="header-cell date">{{$t('account_translate_recent_date')}}</div>
          </div>

          <div class="table-body">
            <div
              v-for="file in sortedFiles"
              :key="file.id"
              class="table-row"
            >
              <div class="table-cell checkbox">
                <input
                  v-if="file.userId == userInfo.id || userInfo.bizTeamMemberRole == 1"
                  type="checkbox"
                  :checked="selectedFiles.includes(file.id)"
                  @change="toggleFileSelection(file.id)"
                />
              </div>
              <div class="table-cell name">
                <span
                  class="workbench-file-type"
                  :style="{ backgroundColor: getWorkbenchFileType(file).color }"
                >
                  <WorkbenchIcon :name="getWorkbenchFileType(file).icon" :size="14" />
                </span>
                <span class="file-name" :class="getPermission(file) ? 'name-click' : ''"  @click=" getPermission(file) ? goToTranslate(file) : ''">{{ file.origFileName }}</span>
              </div>
              <div class="table-cell status">
                <span class="status-badge" :class="getStatusClass(file.operateStatus)">
                  {{ getStatusText(file.operateStatus) }}
                </span>
              </div>
              <div class="table-cell creator">{{ file.bizMemberName }}</div>
              <div class="table-cell date">{{ formatDate(file.createTime) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data" v-else>
          <h2 class="no-data-title">{{$t('account_translate_recent')}}</h2>
          <div class="no-data-content">
              <i class="iconfont icon-icon_blank1" />
              <span class="no-data-text">{{$t('no_data')}}</span>
          </div>
      </div>
    </div>
    <!-- 文本翻译 -->
    <div v-show="tabIndex == 1" class="translate-text-panel">
      <AITranslate enterprise-mode ref="aiRef" @aiHistoryOpen="aiHistoryOpen" @onProBuy="onProBuy" @clearChat="onClearChat">
          <!-- <CommonUploadBottom
            :translateType="translateType"
            :btnsTitle="getBtnsTitle"
            :translateLangsName="translateLangsName"
            :currentLangsName="currentLangsName"
            :showLangError="showLangError"
            :shakeAnimation="shakeAnimation"
            :currentParam="currentParam"
            :resultClick="resultClick"
            :ignoreFileType="ignoreFileType"
            :ignoreValuesList="ignoreValuesList"
            :termActiveIds="termActiveIds"
            :showTranslateImages="showTranslateImages"
            :resultLength="resultLength"
            :filterCurrentMode="filterCurrentMode()"
            @onSelectChange="onSelectChange"
            @switchLangs="switchLangs"
            @freeSpeedUp="freeSpeedUp"
            @onTranslate="onTranslate"
            @onUpPro="onUpPro"
            @onUpdataArt="onUpdataArt"
            @onUpdataField="onUpdataField"
            @ignoreValues="ignoreValues"
            @onOpenTranslateImages="onOpenTranslateImages"
            @freeUpMember="freeUpMember"
            @lastTranslate="lastTranslate"
            @gotoCheckHelp="gotoCheckHelp"
            @onModeChange="onModeChange"
            @onTargetChange="onTargetChange"
            @onLockLang="onLockLang"
          /> -->
        </AITranslate>
    </div>
  </div>
</template>

<script setup lang="ts">

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { ElLoading } from 'element-plus';
import DeleteDialog from '../Dialog/DeleteDialog.vue'
import Toast from "@/utils/toast";
import AccountServer from '@/services/AccountServer';
import useUserStore from '@/store/modules/user';
import { PermissionUtils, EnterpriseMemberPermission, type FileItem } from '@/services/AccountServer/types';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { formatDate } from "@/utils"
import AiHistory from '@/components/aiTranslateComponents/aiHistory.vue'
import { getProBusinessFuelBagConfig, getProBusinessSubscribeConfig } from '@/config/proConfig'
import ProDialog from '@/components/Pro/ProDialog/ProDialog.vue'
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'
import { getReadModeArtifactKey, isReadModeRecord } from '@/utils/enterpriseTranslate'
import { parseJsonIfPossible } from '@/utils/safeJson'
import { useEnterpriseImageNavigation } from '~/composables/useEnterpriseImageNavigation'
import { canAccessEnterpriseImage, isEnterpriseImageRecord } from '~/utils/enterpriseImage'
import { isExcelTranslationExtension } from '@/utils/translationFileType'

const tabView = defineAsyncComponent(() => import("@/components/TranslateComponents/newTabView.vue"))

const router = useRouter()
const openImageRecord = useEnterpriseImageNavigation()
const route = useRoute()
const userStore = useUserStore()
const {userInfo, bizTeamInfo} = storeToRefs(userStore)
const { t, locale } = useI18n()
const tabIndex = ref(route.query.translate === 'text' ? 1 : 0) // 0: 上传翻译 1: 文本翻译
const aiHistoryRef = ref()

// 定义请求参数类型
const params = {
  pageSize: 4,
  pageNo: 1,
  pageTotalSize: 0,
  recordIds: null as number[] | null,
  prevPageId: null as number | null,
  nextPageId: null as number | null
}

// 文件数据
const files = ref<FileItem[]>([])

// 排序方式
const sortOrder = ref<'new' | 'old'>('new')

// 选中的文件
const selectedFiles = ref<string[]>([])

// 文件输入引用
const fileInput = ref<HTMLInputElement>()

watch(() => bizTeamInfo.value?.id, (teamId) => {
  if (teamId) {
    void getRecentFiles()
  }
}, { immediate: true, flush: 'post' })

watch(route, (newVal, oldVal)=>{
  if(newVal.query.menu?.includes('home')){
    getRecentFiles()
  }
})

watch(() => route.query.translate, (value) => {
  tabIndex.value = value === 'text' ? 1 : 0
})

function onChangeType (value: number) {
  tabIndex.value = value
  const query = { ...route.query }

  if (value === 1) {
    query.translate = 'text'
  } else {
    delete query.translate
  }

  void router.replace({ query })
}
const getPermission = (file: FileItem) => {
  if (isEnterpriseImageRecord(file)) return canAccessEnterpriseImage(file, userInfo.value, 'view')
  return file.operateStatus == 1 && (PermissionUtils.hasPermission(userInfo.value.bizMemberpermission, EnterpriseMemberPermission.FILE_LOOK) || file.userId == userInfo.value.id || userInfo.bizTeamMemberRole == 1)
}

// 计算属性
const sortedFiles = computed(() => {
  return [...files.value].sort((a, b) => {
    const dateA = new Date(a.createTime).getTime()
    const dateB = new Date(b.createTime).getTime()
    return sortOrder.value === 'new' ? dateB - dateA : dateA - dateB
  })
})

const isAllSelected = computed(() => {
  return files.value.length > 0 && selectedFiles.value.length === files.value.length
})

const hasSelected = computed(() => {
  return selectedFiles.value.length > 0
})

function getWorkbenchFileType(item: FileItem) {
  const extension = item.origFileName.split('.').pop()?.toLowerCase()
  if (isExcelTranslationExtension(extension)) return { icon: 'table', color: '#30a46c' }
  if (extension === 'docx') return { icon: 'align-left', color: '#3e63dd' }
  if (extension === 'pptx') return { icon: 'presentation', color: '#e5484d' }
  if (['png', 'jpg', 'jpeg', 'webp'].includes(extension || '')) return { icon: 'image', color: '#0090ff' }
  if (['txt', 'srt', 'epub'].includes(extension || '')) return { icon: 'file-scan', color: '#0090ff' }
  return { icon: 'file-text', color: '#e5484d' }
}

const toggleSelectAll = () => {
  if (isAllSelected.value) {
    selectedFiles.value = []
  } else {
    files.value.forEach(file => {
      if (file.userId == userInfo.value.id || userInfo.value.bizTeamMemberRole == 1) {
        selectedFiles.value.push(file.id)
      }
    })
  }
}

const goToTranslate = (file: FileItem) => {
  if (openImageRecord(file)) return
  AccountServer.getAccountFileCompare({ operateRecordId: file.id }).then((result) => {
    if (result.code === "1") {
      let routerPath = '/home/PDFTranslate'
      // 获取当前页面的完整域名
      const origin = window.location.origin;
      // 获取当前路径
      const path = window.location.pathname;
      // 获取第一级路由
      const firstLevelRoute = path.split('/')[1]; // 分割路径并获取第一级路由
      // window.open(href, '_blank');

      if (isReadModeRecord(file)) {
        const resultBlobName = result.data.operateBlobName || file.blobFileName || ''
        const { href } = router.resolve({
          path: '/home/ReadMarkdown',
          query: {
            oldPDF: result.data.sourceBlobName,
            newPDF: resultBlobName,
            operateRecordId: file.id,
            queryKey: getReadModeArtifactKey(resultBlobName),
            filename: file.origFileName,
          },
        })
        const link = document.createElement('a')
        link.setAttribute('href', href)
        link.setAttribute('target', '_blank')
        link.style.display = 'none'
        link.click()
        return
      }

      if (file.fileType == 'docx') {
        routerPath = '/home/WordTranslate'
      } else if (isExcelTranslationExtension(file.fileType)) {
        routerPath = '/home/ExcelTranslate'
      } else if (file.fileType == 'pptx') {
        routerPath = '/home/PPTXTranslate'
      } else if (file.fileType == 'txt' || file.fileType == 'srt') {
        routerPath = '/home/TextTranslate'
      } else if (file.fileType == 'png' || file.fileType == 'jpg' || file.fileType == 'jpeg') {
        routerPath = '/home/ImageTranslate'
      }

      console.log('href===',routerPath)
      const { href } = router.resolve({
        path: routerPath,
        query: { oldPDF: `${result.data.sourceBlobName}`, newPDF: `${result.data.operateBlobName}`, operateRecordId: file.id },
      });
      
      var a = document.createElement('a');
      a.setAttribute('href', href);
      a.setAttribute('target', '_blank');
      a.style.display = 'none';
      a.click();
    }
  }).catch(() => {

  })
}


const toggleFileSelection = (fileId: string) => {
  const index = selectedFiles.value.indexOf(fileId)
  if (index > -1) {
    selectedFiles.value.splice(index, 1)
  } else {
    selectedFiles.value.push(fileId)
  }
}

const deleteDialogRef = ref<InstanceType<typeof DeleteDialog>>()
const deleteSelected = () => {
  if (selectedFiles.value.length == 0) {
    return
  }
  let files = sortedFiles.value.filter(file => selectedFiles.value.includes(file.id))
  deleteDialogRef.value?.open(0, undefined, files)
  // if (confirm(`确定要删除选中的 ${selectedFiles.value.length} 个文件吗？`)) {
  //   files.value = files.value.filter(file => !selectedFiles.value.includes(file.id))
  //   selectedFiles.value = []
  // }
}

const getStatusClass = (status: number) => {
  const statusMap = {
    0: 'status-translating',
    1: 'status-success',
    2: 'status-failed',
  }
  return statusMap[status as keyof typeof statusMap] || ''
}

const getStatusText = (status: number) => {
  if(status == 0) {
    return t('account_translate_recent_status_translating')
  } else if (status == 1) {
    return t('account_translate_recent_status_success')
  } else if (status == 2) {
    return t('account_translate_recent_status_failed')
  }
  return ''
}

function goBack() {
  router.back()
}

function handleDeleteCall() {
  selectedFiles.value = []
  getRecentFiles()
}

async function getRecentFiles() {

  if (!bizTeamInfo.value || !bizTeamInfo.value.id) {
    return
  }
  
  let loading;
  let listDom = document.getElementById("fileUseList")
  if (listDom) {
    loading = ElLoading.service({
        lock: true,
        target: listDom
    })
  }
  console.log('loading-====?>>>>', loading)
  let param = {
    pageSize: 4,
    pageNo: params.pageNo
  }
  if (params.recordIds) {
    param.recordIds = params.recordIds
  }
  param["modeType"] = 0;
//   eventBus.emit('updateHomePage')

  AccountServer.getRequestAccountUseFilePageList(param).then((res) => {
    console.log('res===>>', res)
    if (res.code == "1") {
      let list = res.dataList
      if (list && list.length > 0) {

        list.forEach((item) => {
          item.operateTag = parseJsonIfPossible(item.operateTag) as typeof item.operateTag
          item.remark = parseJsonIfPossible(item.remark) as typeof item.remark
          item.transReqJson = parseJsonIfPossible(item.transReqJson) as typeof item.transReqJson
        })
        params.pageTotalSize = res.totalPageCount ?? 0;
        files.value = list
      } else {
        files.value = [];
      }
      loading && loading.close()
    }
    
  }).catch((error) => {
    Toast(error.message);
    loading && loading.close()
  })
}

function translateSuccess() {
  getRecentFiles()
  userStore.getUserInfo()
}

function taskCompleted(res) {
  if (openImageRecord({ ...res.file, id: res.translateId || res.file?.id })) return
  AccountServer.getAccountFileCompare({ operateRecordId: res.translateId }).then((result) => {
    if (result.code === "1") {
      let routerPath = '/home/PDFTranslate'
      // 获取当前页面的完整域名
      const origin = window.location.origin;
      // 获取当前路径
      const path = window.location.pathname;
      // 获取第一级路由
      const firstLevelRoute = path.split('/')[1]; // 分割路径并获取第一级路由
      // window.open(href, '_blank');

      if (res.targetType === 2 && res.file.fileType === 'pdf') {
        const resultBlobName = res.file.blobFileName || result.data.operateBlobName || ''
        const { href } = router.resolve({
          path: '/home/ReadMarkdown',
          query: {
            oldPDF: `${result.data.sourceBlobName}`,
            newPDF: resultBlobName,
            operateRecordId: res.file.id,
            queryKey: getReadModeArtifactKey(resultBlobName),
            filename: res.name,
          },
        })
        const link = document.createElement('a')
        link.setAttribute('href', href)
        link.setAttribute('target', '_blank')
        link.style.display = 'none'
        link.click()
        return
      } else if (res.file.fileType == 'docx') {
        routerPath = '/home/WordTranslate'
      } else if (isExcelTranslationExtension(res.file.fileType)) {
        routerPath = '/home/ExcelTranslate'
      } else if (res.file.fileType == 'pptx') {
        routerPath = '/home/PPTXTranslate'
      } else if (res.file.fileType == 'txt' || res.file.fileType == 'srt') {
        routerPath = '/home/TextTranslate'
      } else if (res.file.fileType == 'png' || res.file.fileType == 'jpg' || res.file.fileType == 'jpeg') {
        routerPath = '/home/ImageTranslate'
      }

      console.log('href===',routerPath)
      const { href } = router.resolve({
        path: routerPath,
        query: { oldPDF: `${result.data.sourceBlobName}`, newPDF: `${result.data.operateBlobName}`, operateRecordId: res.file.id },
      });
      
      var a = document.createElement('a');
      a.setAttribute('href', href);
      a.setAttribute('target', '_blank');
      a.style.display = 'none';
      a.click();
    }
  }).catch(() => {

  })
}
// ai 对话相关
const proDialogRef = inject('proDialogRef') as Ref<InstanceType<typeof ProDialog>>

function onProBuy(index) {
  let coinKey = userStore.getCurrentCoin(locale.value)
  if (index == 1) {
    // 字符不足
    const items = getProBusinessFuelBagConfig(coinKey)
    proDialogRef.value?.open({...items[0], mode: 1})
  }else {
    // 过期了
    const items = getProBusinessSubscribeConfig(coinKey)
    proDialogRef.value?.open({...items[0], mode: 0})
  }
}

function aiHistoryOpen() {
  aiHistoryRef.value && aiHistoryRef.value.aiHistoryOpen()
}

const resetScrollViewTop = () => {
  if (document.body) {
    document.body.scrollTop = 0
  }
}

function onClearChat() {
  console.log('onClearChat')
  resetScrollViewTop()
}

</script>

<style lang="scss" scoped>
.translate-home {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;

  .translate-home-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    margin-bottom: 18px;
  }
}

.page-back {
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e3e7ec;
  border-radius: 8px;
  &:hover {
    opacity: 0.7;
  }
}

.translate-document-panel {
  margin-top: 18px;
}

.translate-text-panel {
  flex: 1;
  min-height: 0;
  margin-top: 18px;
  overflow: hidden;
}

:deep(.tab-view-header) {
  height: 31px !important;
  padding: 0 !important;

  .tab-item_view {
    box-sizing: border-box;
    flex: 0 0 auto;
    width: auto !important;
    min-width: 85px !important;
    height: 31px !important;
    padding: 0 14px !important;
    color: #5f6672 !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    line-height: 31px !important;
    white-space: nowrap;
    border-color: #d9dee5 !important;
    border-radius: 15px !important;

    &.active-tab {
      color: #fff !important;
      font-weight: 600 !important;
      background: #2f80ed !important;
      border-color: #2f80ed !important;
    }
  }
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.upload-section {
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-area {
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  padding: 48px 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    border-color: #1890ff;
    background-color: #f8f9fa;
  }
}

.upload-content {
  pointer-events: none;
}

.upload-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.upload-text {
  font-size: 18px;
  color: #333;
  margin-bottom: 16px;
}

.file-types {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.file-type {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  
  &.pdf { background-color: #ff4d4f; }
  &.excel { background-color: #52c41a; }
  &.word { background-color: #1890ff; }
  &.ppt { background-color: #ff4d4f; }
  &.doc { background-color: #52c41a; }
  &.image { background-color: #1890ff; }
}

.upload-limit {
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.info-icon {
  font-size: 12px;
}

.file-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.recent-section {
  background-color: #fff;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 17px;
}

.section-title {
  font-size: 14px;
  font-weight: 800;
  line-height: 18px;
  color: #1f2329;
  margin: 0;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  .icon-icon_delete {
    font-size: 16px;
  }
}

.sort-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  
  &:hover {
    border-color: #1890ff;
  }
}

.sort-text {
  font-size: 14px;
  color: #333;
}

.sort-arrow {
  font-size: 12px;
  color: #666;
}

.sort-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: none;
  
  .sort-dropdown:hover & {
    display: block;
  }
}

.sort-item {
  padding: 8px 12px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  
  &:hover {
    background-color: #f5f5f5;
  }
}

.delete-btn {
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  font-size: 16px;
  
  &:hover:not(:disabled) {
    border-color: #ff4d4f;
    color: #ff4d4f;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.file-table {
  width: 100%;
}

.table-header {
  display: grid;
  grid-template-columns: 14px minmax(0, 1fr) 250px 320px 280px;
  gap: 10px;
  height: 35px;
  box-sizing: border-box;
  padding: 9px 8px;
  border-bottom: 1px solid #eef1f5;
  font-weight: 400;
  font-size: 12px;
  color: #98a2b3;
}

.table-body {
  // max-height: 400px;
  // overflow-y: auto;
}

.table-row {
  display: grid;
  grid-template-columns: 14px minmax(0, 1fr) 250px 320px 280px;
  gap: 10px;
  min-height: 46px;
  box-sizing: border-box;
  padding: 11px 8px;
  border-bottom: 1px solid #eef1f5;
  align-items: center;
  
  &:hover {
    background-color: #f8f9fa;
  }
}

.table-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.workbench-file-type {
  display: inline-flex;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #fff;
  border-radius: 5px;
}

.header-cell {
  display: flex;
  align-items: center;
  color: #98a2b3;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
}

.checkbox {
  justify-content: center;
}

.table-cell.name {
    font-size: 12.5px;
    color: #1f2329;
  .file-icon {
    font-size: 16px;
  }
  
  .file-name {
    overflow: hidden;
    color: #1f2329;
    font-size: 12.5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid transparent;
  }
  .name-click {
    cursor: pointer;
    padding: 2px 0;
    &:hover {
      color: #2590E1;
      border-bottom: 1px solid #2590E1;
    }
  }
}


.status-badge {
  padding: 0;
  border-radius: 12px;
  font-size: 12.5px;
  color: #fff;
  
  &.status-translating {
    color: #F09308;
  }
  
  &.status-success {
    color: #595959;
  }
  
  &.status-failed {
    color: #595959;
  }
}

.table-cell.creator,
.table-cell.date {
  font-size: 12.5px;
  color: #5f6672;
}

.table-header input[type="checkbox"],
.table-row input[type="checkbox"] {
  width: 14px;
  height: 14px;
  margin: 0;
}

.no-data {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    .no-data-title {
        font-size: 14px;
        font-weight: 800;
        line-height: 18px;
        color: #1f2329;
        margin: 0;
    }
    .no-data-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        margin-top: 60px;
        .icon-icon_blank1
        {
            font-size: 48px;
            color: #BFBFBF;
        }
        .no-data-text {
            color: #BFBFBF;
            font-size: 12px;
            margin-top: 10px;
        }
    }
}

input[type="checkbox"] {
  accent-color: #2590E1; /* 改为红色 */
}
</style>
